/* components */
const Lookup = () => import(/* webpackChunkName: "PlanLookupList" */ '@/views/H5/lookup.vue')
const PlanList = () => import(/* webpackChunkName: "PlanList" */ '@/views/H5/planList.vue')
const PlanListRight = () => import(/* webpackChunkName: "PlanListRight" */ '@/views/H5/planListRight.vue')
const Payment = () => import(/* webpackChunkName: "Payment" */ '@/views/H5/payment.vue')
const CustomerService = () => import(/* webpackChunkName: "CustomerService" */ '@/views/H5/customer_service.vue')

/* 404 */
const NotFound = () => import(/* webpackChunkName: "NotFound" */ '@/components/common/notFound.vue')

export const routes = [
  {
    path: '/',
    redirect: '/lookup',
    meta: {
      title: '卡号查询'
    },
    component: Lookup
  }, {
    path: '/lookup',
    meta: {
      title: '卡号查询'
    },
    component: Lookup
  },
  {
    path: '/planList',
    meta: {
      title: '详情'
    },
    component: PlanList
  }, {
    path: '/planListRight',
    meta: {
      title: '套餐列表'
    },
    component: PlanListRight
  }, {
    path: '/payment',
    meta: {
      title: '充值'
    },
    component: Payment
  }, {
    path: '/customer_service',
    meta: {
      title: '客服'
    },
    component: CustomerService
  }, {
    path: '*',
    meta: {
      title: 'NotFound'
    },
    component: NotFound
  }
]
